import "./src/styles/global.css"

import React from "react"

import RootWrapper from "./src/components/RootWrapper"
import { trackPageView } from "./src/analytics"

export const wrapRootElement = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>
}

export const onRouteUpdate = ({ location }) => {
  trackPageView(location?.pathname)
}
